import {FC} from 'react'

import cn from 'classnames/bind'

import s from './BrainableBlock.module.scss'

const cx = cn.bind(s)

interface IBrainableBlockProps {
	className?: string
	title: string
	dense: boolean
}

const BrainableBlock: FC<IBrainableBlockProps> = ({
	children,
	className,
	title,
	dense = false,
	...attrs
}) => (
	<div className={cx(className, 'block')} {...attrs}>
		<h2 className={cx('blockTitle', {blockTitleDense: dense})}>{title}</h2>
		{children}
	</div>
)

export default BrainableBlock
